export default {


    computed: {
        //异常类型
        //         PUSH_ERROR(0,"推送异常"),
        // RETURN_ERROR(1,"回传异常"),
        // CANCEL_ERROR(2,"取消异常"),
        // ESTIMATE_ERROR(3,"测算异常"),
        // BUY_LABEL_ERROR(4,"label购买异常"),
        // CHECK_ERROR(5,"审核异常");
        getAbnormalType() {
            return [{
                label: "推送异常",
                value: 0
            }, {
                label: "回传异常",
                value: 1
            }, {
                label: "取消异常",
                value: 2
            }, {
                label: "测算异常",
                value: 3
            }, {
                label: "Label购买异常",
                value: 4
            }, {
                label: "审核异常",
                value: 5
            },
                {
                    label: "完成异常",
                    value: 6
                },{
                    label: "发运异常",
                    value: 7
                },{
                label: "确认异常",
                value: 10
            },
                {
                    label: "附件推送异常",
                    value: 11
                },
            {
                label: "wms单据创建异常",
                value: 8
            },{
                label: "wms单据完成异常",
                value: 9
            },]
        },
        //单据类型
        getBillType() {
            return [{
                label: "销售出库计划单",
                value: 200
            }, {
                label: "调拨出库计划单",
                value: 300
            }, {
                label: "调拨入库计划单",
                value: 320
            }, {
                label: "调拨计划单",
                value: 301
            }, {
                label: "普通调拨",
                value: 302
            }, {
                label: "调拨出库执行单",
                value: 310
            }, {
                label: "调拨入库执行单",
                value: 330
            }, {
                label: "销售退货计划单",
                value: 410
            },{
                label: "入库计划单",
                value: 420
            }, {
                label: "入库单",
                value: 430
            }, {
                label: "预约入库单",
                value: 520
            },{
                label: "事务计划单",
                value: 500
            },{
                label: "事务执行单",
                value: 510
            },{
                label: "中转计划单",
                value: 600
            },{
                label: "中转入库单",
                value: 610
            },{
                label: "中转出库单",
                value: 620
            }, {
                label: "库存异动单据",
                value: 700
            }, {
                label: "移库单",
                value: 720
            }]
        },
        //异常模块
        getBillModule() {
            return [{
                label: "销售出库计划单",
                value: 200
            }, {
                label: "调拨计划单",
                value: 301
            }, {
                label: "调拨出库执行单",
                value: 310
            }, {
                label: "调拨入库执行单",
                value: 330
            }, {
                label: "销售退货计划单",
                value: 410
            },{
                label: "入库计划单",
                value: 420
            }, {
                label: "入库单",
                value: 430
            },{
                label: "事务计划单",
                    value: 500
            },{
                label: "事务执行单",
                    value: 510
            }, {
                label: "中转计划单",
                value: 600
            }, {
                label: "库存异动单据",
                value: 700
            }, {
                label: "移库单",
                value: 720
            }]
        },
        //状态
        getBillStatus() {
            // UNPROCESSED(0,"未处理"),
            // PROCESSED(1,"已处理"),
            // IGNORED(2,"忽略");
            return [{
                label: "未处理",
                value: 0,
                theme: 'error'
            }, {
                label: "已处理",
                value: 1,
                theme: 'success'
            }, {
                label: "忽略",
                value: 2,
                theme: 'info'
            }]
        },
        //操作类型
        getOperateType() {
            // PUSH_WAREHOUSE(1,"推送仓库"),
            // CANCEL_PUSH_WAREHOUSE(2,"取消推送仓库"),
            // TRACKING_PUSH_WAREHOUSE(3,"tracking推送仓库"),
            // WRITE_BACK_BOSS(4,"回传boss"),
            // WRITE_BACK_FBB(5,"回写云仓"),
            // INVENTORY_TASK_WRITE_BACK(6,"库存变动回写boss"),
            // INVENTORY_TASK_WRITE_BACK_VIRTUAL(7,"库存变动回写虚拟库存模块"),
            // CHECK(8,"审核"),
            // PUSH_ATTACH(9,"推送附件"),
            // WMS_WRITE_BACK_FBB(10,"wms回传fbb"),
            // WAREHOUSEDOCKING_WRITE_BACK_FBB(11,"warehousedocking回传fbb"),
            // SHIPMENT_CONFIRM_PUSH_TO_BOSS(13,"发运推送boss"),
            // COMPLETE(12,"完成"),
            // LOGISTICS_SHIP(14,"物流发运"),
            // PUSH_TO_LOGISTICS(15,"推送物流"),
            // AUDITED_APPROE_PUSH_TO_BOSS(16,"审核通过推送boss"),
            // AUDITED_REFUSE_PUSH_TO_BOSS(17,"审核拒绝推送boss"),

            return [{
                label: "推送仓库",
                value: 1,
            }, {
                label: "取消推送仓库",
                value: 2,
            }, {
                label: "tracking推送仓库",
                value: 3,
            }, {
                label: "回传boss",
                value: 4,
            }, {
                label: "回写云仓",
                value: 5,
            }, {
                label: "库存变动回写boss",
                value: 6,
            }, {
                label: "库存变动回写虚拟库存模块",
                value: 7,
            }, {
                label: "审核",
                value: 8,
            },
            {
                label: "确认",
                value: 21,
            }, {
                label: "推送附件",
                value: 9,
            }, {
                label: "wms回传fbb",
                value: 10,
            }, {
                label: "warehousedocking回传fbb",
                value: 11,
            }, {
                label: "完成",
                value: 12,
            }, {
                label: "发运推送boss",
                value: 13,
            }, {
                label: "物流发运",
                value: 14,
            }, {
                label: "推送物流",
                value: 15,
            }, {
                label: "审核通过推送boss",
                value: 16,
            }, {
                label: "审核拒绝推送boss",
                value: 17,
            }, {
                label: "发运",
                value: 19
            }, {
                label: "回写sap",
                value: 22
            }]
        },


    },
}
